import type { DashboardWarehouseStat } from '@nebalkon-workspace/admin-api';

/** Formats m³ values with comma decimal separator (ru locale). */
export function formatDashboardVolumeM3(value: number): string {
  return value.toFixed(2).replace('.', ',');
}

/** Clamps warehouse occupancy to a valid horizontal bar width (0–100). */
export function warehouseOccupancyBarWidth(warehouse: DashboardWarehouseStat): number {
  const percent = warehouse.occupancy_percent;
  if (!Number.isFinite(percent)) {
    return 0;
  }

  return Math.min(100, Math.max(0, percent));
}

/** Formats occupied volume as `12,40 / 50,00 м³ (25,00%)` when total is known. */
export function formatOccupiedVolumeLabel(
  occupiedM3: number,
  usefulVolumeM3: number,
  occupancyPercent: number,
): string {
  const percentLabel = formatDashboardVolumeM3(occupancyPercent);

  if (usefulVolumeM3 <= 0) {
    return `${formatDashboardVolumeM3(occupiedM3)} м³ (${percentLabel}%)`;
  }

  return `${formatDashboardVolumeM3(occupiedM3)} / ${formatDashboardVolumeM3(usefulVolumeM3)} м³ (${percentLabel}%)`;
}

/** Per-warehouse volume label for dashboard cards and table rows. */
export function formatWarehouseVolumeLabel(
  warehouse: DashboardWarehouseStat,
): string {
  return formatOccupiedVolumeLabel(
    warehouse.volume_m3,
    warehouse.useful_volume_m3 ?? 0,
    warehouse.occupancy_percent,
  );
}
